
const Setting = {
  // 网页标题的后缀
  titleSuffix:"家谱系统",

  // 路由模式，可选值为 history 或 hash
  routerMode: 'history',
  //系统版本号
  version : "0.0.1",
  // 页面切换时，是否显示模拟的进度条
  showProgressBar: true,
  // 接口请求地址
  apiBaseURL:"https://api.jiapu0576.com",
  //apiBaseURL:"http://192.168.1.108:8004",
  //puttoken
  key   : "295ce6711606eaea5a2e8f0c4703e7b7",
  //
  appSalt : "u$ii#uH!uF7LJkz&a4fcE50AdzHIbBAH",
  // socket连接  
//  wsUrl: 'ws://127.0.0.1:9506/pc',
  wsUrl: 'wss://api.huiyoumis.cn:9506/pc',
  //socket Key
  wsKey: "u$ii#uH!uF7LJkz&a4fcE50AdzHIbBAH",

  //接口请求返回错误时，弹窗的持续时间，单位：秒
  modalDuration: 3,

  //接口请求返回错误时，弹窗的类型，可选值为 Message 或 Notice
  errorModalType: 'Message',

  //Cookies 默认保存时间，单位：天
  cookiesExpires: 1
};
export default Setting;
